import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, FileText, Zap, BookOpen, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { scrollToPricing } from './utils';
export function Hero() {
  return <section className="relative pt-5 pb-5 md:pt-16 md:pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden flex flex-col items-center text-center min-h-[100svh] justify-center" data-id="element-137">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-lilac-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-138" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="relative z-10 max-w-4xl mx-auto flex flex-col items-center" data-id="element-139">
        <div className="inline-flex items-center gap-2 px-3 py-1 md:px-4 md:py-1.5 rounded-full bg-mystic-800/80 border border-gold-500/30 text-gold-400 text-[10px] md:text-sm font-medium mb-3 md:mb-8 tracking-wider uppercase" data-id="element-140">
          <Sparkles className="w-3 h-3 md:w-4 md:h-4" data-id="element-141" />
          <span data-id="element-142">ASTRO SER · EL CÓDIGO DEL MAGNETISMO</span>
          <Sparkles className="w-3 h-3 md:w-4 md:h-4" data-id="element-143" />
        </div>

        <h1 className="text-3xl md:text-6xl lg:text-7xl font-bold text-white mb-3 md:mb-6 leading-[1.1]" data-id="element-144">
          Todo tu patrón de amor <br className="hidden md:block" data-id="element-145" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-300 via-gold-400 to-gold-600 italic" data-id="element-146">
            roto de una vez.
          </span>
        </h1>

        {/* Main Product Image Placeholder */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full max-w-lg mx-auto mb-3 md:mb-8 relative" data-id="element-147">
          <img src="https://cdn.magicpatterns.com/uploads/py2HWkKaLRfhyBZmNXMBTY/mock_magnetismo.png" alt="Megapack El Código del Magnetismo - Elite Bundle" className="w-full h-auto max-h-[28vh] md:max-h-none object-contain mx-auto drop-shadow-[0_20px_60px_rgba(168,85,247,0.35)] hover:scale-105 transition-transform duration-700" data-id="element-148" />
        </motion.div>

        <p className="text-base md:text-2xl text-lilac-300 font-serif mb-2 md:mb-4" data-id="element-149">
          Megapack EL CÓDIGO DEL MAGNETISMO — Sistema Completo Nivel Élite
        </p>

        <p className="hidden md:block text-base md:text-lg text-slate-300 max-w-2xl mb-8 leading-relaxed" data-id="element-150">
          El sistema completo de astrología, energía y reprogramación
          subconsciente para la mujer argentina que se cansó de atraer hombres
          que no la eligen, vínculos fríos y amor a medias.
        </p>

        {/* Format Badges */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-4 md:mb-10" data-id="element-151">
          <div className="flex items-center gap-1.5 px-2.5 py-1 bg-mystic-800 rounded-md text-xs md:text-sm text-slate-200 border border-mystic-700" data-id="element-152">
            <FileText className="w-3.5 h-3.5 md:w-4 md:h-4 text-lilac-400" data-id="element-153" />
            📄 PDF
          </div>
          <div className="flex items-center gap-1.5 px-2.5 py-1 bg-mystic-800 rounded-md text-xs md:text-sm text-slate-200 border border-mystic-700" data-id="element-154">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-400" data-id="element-155" />⚡ Acceso
            Inmediato
          </div>
          <div className="flex items-center gap-1.5 px-2.5 py-1 bg-mystic-800 rounded-md text-xs md:text-sm text-slate-200 border border-mystic-700" data-id="element-156">
            <BookOpen className="w-3.5 h-3.5 md:w-4 md:h-4 text-lilac-400" data-id="element-157" />
            📚 12 Tomos + 6 Bonus + 2 Élite
          </div>
        </div>

        {/* Primary CTA */}
        <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} onClick={scrollToPricing} className="w-full sm:w-auto px-8 py-3.5 md:py-4 bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-400 hover:to-gold-500 text-mystic-900 font-bold text-base md:text-lg rounded-full shadow-[0_0_30px_rgba(212,175,55,0.3)] transition-all flex items-center justify-center gap-2" data-id="element-158">
          💜 QUIERO MI MEGAPACK AHORA
        </motion.button>

        {/* Trust Line */}
        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 mt-3 md:mt-6 text-xs md:text-sm text-slate-400" data-id="element-159">
          <span className="flex items-center gap-1.5" data-id="element-160">
            <ShieldCheck className="w-4 h-4" data-id="element-161" /> 🛡️ Garantía 7 días
          </span>
          <span className="hidden sm:inline text-mystic-700" data-id="element-162">|</span>
          <span className="flex items-center gap-1.5" data-id="element-163">
            <Lock className="w-4 h-4" data-id="element-164" /> 🔒 Pago seguro
          </span>
          <span className="hidden sm:inline text-mystic-700" data-id="element-165">|</span>
          <span className="flex items-center gap-1.5" data-id="element-166">
            <CreditCard className="w-4 h-4" data-id="element-167" /> 💳 Tarjetas y transferencia
          </span>
        </div>
      </motion.div>
    </section>;
}